import { useAppSelector } from '../../store/store';
import { Navigate, Outlet } from 'react-router';

const PublicRoute = () => {
  const user = useAppSelector((state) => state.user.user);

  // If the user is already logged in, redirect them to a protected page (e.g., the profile).
  if (user && user.SessionId) {
    return <Navigate to="/user/profile" replace />;
  }

  // If the user is not logged in, render the public page.
  return <Outlet />;
};

export default PublicRoute;